import createStore from "zustand";
import persist from "../utils/persist";

const useGmailStore = createStore(
  persist(
    {
      key: "gmailToken",
      denylist: ["isLoading", "errorMessage"],
    },
    (set) => ({
      isLoading: false,
      errorMessage: "",
      googleToken: null,
      gmailLogged: false,

      setToken: (data) => {
        set(() => ({
          googleToken: data,
        }));
      },

      setLoggedIn: (data) => {
        set(() => ({
          gmailLogged: data,
        }));
      },

      clearToken: () => {
        set(() => ({
          googleToken: null,
          gmailLogged: false,
        }));
      },
    })
  )
);

export default useGmailStore;
